import { Button, Col, Divider, Modal, Popover, Row } from "antd";
import React, { useState } from "react";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import useIsDesktop from "../../../utils/hooks/useIsDesktop";
import Typography from "../../Typography";
import { COLORS } from "../../../constants/Colors";
import MyButton from "../../Button";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { confirm } = Modal;

const ConfirmCreateQueue = (title,ok) => {
  const isDesktop = useIsDesktop();
  const intl = useIntl();
  confirm({
    title: (
      <Typography
        isBold
        color={COLORS.Purple}
        style={{ lineHeight: "1.5" }}
        size="18px"
        className="text-left pt-2"
      >
        {title}
      </Typography>
    ),
    icon: (
      <ExclamationCircleOutlined
        className="pt-2"
        style={{ color: COLORS.YellowPending, fontSize: "28px" }}
      />
    ),
    style: { marginLeft: "-10px" },
    width: isDesktop ? 550 : "100%",
    centered: true,
    okButtonProps: {
      type: "primary",
      style: {
        backgroundColor: COLORS.Primary, // เปลี่ยนสีปุ่ม
        borderColor: COLORS.Primary,
        color: COLORS.White,
        borderRadius: "8px",
        fontWeight: "bold",
        width: "25%",
      },
      onMouseEnter: (e) => {
        e.target.style.backgroundColor = COLORS.White; // สีเมื่อชี้เมาส์
        e.target.style.borderColor = COLORS.Primary;
        e.target.style.color = COLORS.Primary;
      },
      onMouseLeave: (e) => {
        e.target.style.backgroundColor = COLORS.Primary; // กลับเป็นสีเดิม
        e.target.style.borderColor = COLORS.Primary;
        e.target.style.color = COLORS.White;
      },
    },
    cancelButtonProps: {
      style: {
        backgroundColor: COLORS.White, // เปลี่ยนสีปุ่ม
        borderColor: COLORS.GreenBrown,
        color: COLORS.GreenBrown,
        borderRadius: "8px",
        fontWeight: "bold",
        width: "25%",
      },
      onMouseEnter: (e) => {
        e.target.style.backgroundColor = COLORS.White; // สีเมื่อชี้เมาส์
        e.target.style.borderColor = COLORS.Primary;
        e.target.style.color = COLORS.Primary;
      },
    },
    okText: intl.formatMessage({
      id: "btnConfirm",
      defaultMessage: "ยืนยัน",
    }),
    cancelText: intl.formatMessage({
      id: "btnCancel",
      defaultMessage: "ยกเลิก",
    }),
    onOk() {
      ok()
    },
    onCancel() {
      console.log("Cancel");
    },
  });
};

export { ConfirmCreateQueue };
